'use client'

import Link from 'next/link'
import { usePathname, useSearchParams } from 'next/navigation'

import { languages, type AppLocale } from '@/lib/i18n/settings'

type LocaleSwitcherLinksProps = {
  currentLocale: AppLocale
  localeLabels: Record<AppLocale, string>
}

function buildLocaleHref(pathname: string, locale: AppLocale, query: string) {
  const segments = pathname.split('/').filter(Boolean)
  const hasLocalePrefix = segments.length > 0 && languages.includes(segments[0] as AppLocale)
  const rest = hasLocalePrefix ? segments.slice(1) : segments
  const localizedPath = `/${[locale, ...rest].join('/')}`
  return query ? `${localizedPath}?${query}` : localizedPath
}

export function LocaleSwitcherLinks({ currentLocale, localeLabels }: LocaleSwitcherLinksProps) {
  const pathname = usePathname() || '/'
  const searchParams = useSearchParams()
  const query = searchParams.toString()

  return (
    <>
      {languages.map((code, index) => (
        <span key={code} className="flex items-center gap-3">
          {index > 0 ? <span className="text-charcoal-600">|</span> : null}
          <Link
            href={buildLocaleHref(pathname, code, query)}
            className={code === currentLocale ? 'font-bold text-white' : 'transition-colors hover:text-white'}
          >
            {localeLabels[code] ?? code}
          </Link>
        </span>
      ))}
    </>
  )
}
